export default __webpack_public_path__ + "static/media/msg2.aa5662ac.png";